import { HStack, Stack, Text } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
// import { getArchiveDetails } from "../../services/Archive";

export default function FilmDetails({ archive, filmData }) {
  // const navigate = useNavigate();

  // Utility function to find an item by key
  const findItem = (items, key) => items?.find(item => item.key === key) || {};

  // Extract relevant film data
  const film = findItem(filmData, "titlewithLink")?.value;
  const year = findItem(filmData, "sortable_year")?.value;
  const country = findItem(filmData, "country_of_origin_film")?.value;
  const language = findItem(filmData, "language")?.value;

  // Safely accessing the necessary film details
  const filmTitle = film?.[0]?.fullname;
  const filmAlias = film?.[0]?.alias;
  const countryOfFilm = country?.[0]?.name;
  const languageNames = language ? language.map(lang => lang.name).join(", ") : '';

  // Construct the film title string
  const filmTitleVal = `${filmTitle || ''}, ${year || ''}, ${countryOfFilm || ''}, ${languageNames}`;

  const filmTitleData = {
    display: "Film Title",
    value: filmTitleVal,
    alias: filmAlias
  };

  // // Handle routing on film click
  // const handleRoute = async (alias) => {
  //   try {
  //     const res = await getArchiveDetails(alias);
  //     if (res?.data) {
  //       const routeType = res.data.route_type !== "generic" ? res.data.route_type : "generic";
  //       navigate(`/${routeType}/${alias}/`);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching archive details:", error);
  //   }
  // };

  return (
    <>
      {filmTitleVal && 
      <Stack
      marginInlineStart={
        "0rem!important"
      }
      py="1"
      gap={"0"}
      className="mt-0 px-0"
      flexDirection={"column"}
    >
      <HStack className="mt-0 px-0" flexWrap={"wrap"} gap={"5px"}>
        <Text
           fontSize={{ base: "12px", md: "16px" }}
          fontWeight={"700"}
          color="black"
        >
          {filmTitleData?.display &&
            `${filmTitleData?.display}`}
        </Text>
          <Link
          // onClick={()=>handleRoute(filmTitleData?.alias)}
          // marginInlineStart={"0.0rem!important"}
          className="ml-0"
          >
            <Text
            fontSize={{ base: "12px", md: "16px" }}
            fontWeight={"400"}
            color="color.blue"
          >{filmTitleData?.value}
          </Text>
          </Link>
      </HStack>
    </Stack>
    }
    </>
  );
}
